// extracted by mini-css-extract-plugin
export default {"openButtonMobile":"OpenButtonMobile_openButtonMobile__mDYj+","arrowImage":"OpenButtonMobile_arrowImage__d6xw6"};